import { Grid } from "@mui/material";
import { Fragment, useState } from "react";
import { useDispatch } from "react-redux";

import CampaignStatus from "../../Status";
import AdminCampaignStatus from "../../AdminCampaignStatus";
import CampaignButtons from "./../../CreateCampaignButtons";
import { PageHeader } from "../../../../../components";
import EditButtons from "../../../../../components/EditButtons";
import {
  CancelButton,
  CreateButton,
  PrimaryLoadingButton,
} from "../../../../css components/Button";
import { alert } from "../../../../../redux/slices/alertSlice";
import { useAxios } from "../../../../../hooks";
import Connections from "../../../superadmin campaign details component/ConnectionList";
import { useNavigate } from "react-router-dom";
import pages from "../../../../../constants/pages";

export default function HeadersAndButtons({
  editState,
  liveUsers,
  formikProps,
  setEditState,
  component = "",
  setTakeUpOffer,
  preferredChannels,
  connectionList,
  isSubmitted,
  forceClick,
  setForceClick,
  brandIdentity,
  audienceSize,
  setIsSubmitted,
  activeBrand,
  channelSectionRef,
}) {
  const axios = useAxios();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [loading, setLoading] = useState();

  const scrollToChannelSection = () => {
    channelSectionRef.current?.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  };
  return (
    <Fragment>
      <Grid size={12}>
        <PageHeader
          pageName={
            !formikProps.values.campaignID
              ? `Create Campaign`
              : "Campaign Details"
          }
          pageHeader={
            !formikProps.values.campaignID
              ? "Fill in the details and start reaching your audience."
              : "View your activated audience settings, content, and audience."
          }
          buttons={[
            !!formikProps.values.campaignID &&
              !isSubmitted &&
              (formikProps.values.adminApprovalStatus === "ACCEPTED" ||
                formikProps.values.status === "APPROVAL_REQUESTED") &&
              formikProps.values.campaignStatus !== "Expired" &&
              (forceClick ? (
                <Fragment>
                  <CreateButton
                    variant="contained"
                    onClick={() => {
                      setForceClick(false);
                      scrollToChannelSection();
                    }}
                  >
                    Edit Channel Details
                  </CreateButton>

                  <CancelButton
                    style={{ marginLeft: "10px" }}
                    onClick={() => {
                      if (!forceClick) {
                        navigate(-1);
                      } else {
                        navigate(pages.myCampaign.route);
                      }
                    }}
                    variant="outlined"
                  >
                    Back
                  </CancelButton>
                </Fragment>
              ) : (
                <Fragment>
                  <PrimaryLoadingButton
                    variant="contained"
                    onClick={handleChannelDetails}
                    loading={loading}
                    color="primary"
                    sx={{ marginRight: "4px" }}
                  >
                    Submit
                  </PrimaryLoadingButton>
                  <CancelButton
                    variant="outlined"
                    onClick={() => setForceClick(true)}
                  >
                    Cancel
                  </CancelButton>
                </Fragment>
              )),
            <CampaignButtons
              isDisabled={isSubmitted}
              ID={formikProps.values.campaignID}
              editState={editState}
              liveUsers={liveUsers}
              setEditState={setEditState}
              formikProps={formikProps}
              component={component}
              brandIdentity={brandIdentity}
              setTakeUpOffer={setTakeUpOffer}
              setIsSubmitted={setIsSubmitted}
            />,

            isSubmitted &&
              (formikProps.values.adminApprovalStatus === "REQUESTED" ||
                formikProps.values.adminApprovalStatus === "ACCEPTED") && (
                <CancelButton
                  onClick={() => {
                    navigate(pages.myCampaign.route);
                  }}
                  variant="outlined"
                >
                  Back
                </CancelButton>
              ),

            (formikProps.values.status === "CREATED" ||
              formikProps.values.status === "DRAFT") &&
              formikProps.values.isEditable && (
                <EditButtons
                  ID={formikProps.values.campaignID}
                  formikProps={formikProps}
                  editState={editState}
                  setEditState={setEditState}
                />
              ),
          ]}
        />

        {component !== "" &&
          formikProps.values.campaignStatus !== "REQUESTED" && (
            <Grid size={12}>
              <CampaignStatus
                formikProps={formikProps}
                setTakeUpOffer={setTakeUpOffer}
              />
            </Grid>
          )}

        {component === "" && (
          <Grid size={12}>
            <AdminCampaignStatus
              isDisabled={isSubmitted}
              preferredChannels={preferredChannels}
              audienceSize={audienceSize}
              formikProps={formikProps}
              setForceClick={setForceClick}
              channelSectionRef={channelSectionRef}
              scrollToChannelSection={scrollToChannelSection}
            />
          </Grid>
        )}

        {component === "" &&
          formikProps.values.permissionSettings?.connection_list && (
            <Connections
              connections={connectionList}
              formikProps={formikProps}
            />
          )}
      </Grid>
    </Fragment>
  );

  function checkChannelFields(values) {
    const prefChannels = values?.pref_campaign_channel?.value || [];

    if (prefChannels.length === 0) {
      return false;
    }

    let requiredFields = [];

    if (prefChannels.includes(3)) {
      requiredFields.push("ad_manager_id");
    }

    if (prefChannels.includes(6)) {
      requiredFields.push(
        "dv_partner_id",
        "dv_advertiser_id",
        "dv_advertiser_name"
      );
    }

    // remove duplicates in case both 3 and 6 are selected
    requiredFields = [...new Set(requiredFields)];

    return requiredFields.every((field) => !!values?.[field]?.value);
  }
  function handleChannelDetails() {
    setLoading(true);
    if (!checkChannelFields(formikProps.values)) {
      dispatch(
        alert({
          type: "error",
          message: "Please fill the necessary details for channels.",
        })
      );
      setLoading(false);

      return;
    }
    let fields = [];

    const requiredFields = [
      "dv_partner_id",
      "dv_advertiser_id",
      "dv_advertiser_name",
      "ad_manager_id",
      "pref_campaign_channel",
    ];

    requiredFields
      .filter((f) => formikProps.values[f].value)
      .map((val) => fields.push({ [val]: formikProps.values[val] }));

    let data = {
      brand_id: parseInt(activeBrand.ID),
      audience_id: formikProps.values?.audienceID,
      update_data: true,
      fields: fields,
    };

    axios({
      url: "/user/update/campaign/" + formikProps.values.campaignID,
      method: "PUT",
      data: data,
      disableRedirect: true,
    }).then((response) => {
      if (response.status) {
        setForceClick(true);

        dispatch(
          alert({
            type: "success",
            message: response.message.displayMessage,
          })
        );
        setIsSubmitted(checkChannelFields(formikProps.values));
      }
    });
    setLoading(false);
  }
}
